<template>
  <div>
    <template v-if="type == 'text'">
        <TrfInput
            :id="configuration.id"
            type="text"
            class="is-fullwidth"
            :model-value="value"
            :label="configuration.label"
            :placeholder="configuration.placeholder"
            :mensagem-campo-obrigatorio="configuration.errorMessage"
            :required="configuration.required"
            :disabled="configuration.disabled"
            @update:model-value="$event => setValue($event, configuration)"
            ref="dynamicInput"
            v-e2e="configuration.id"
        ></TrfInput>
    </template>
    <template v-else-if="type == 'select'">
        <TrfSelect
            :id="configuration.id"
            class="is-fullwidth"
            :options="configuration.options"
            :label="configuration.label"
            :placeholder="configuration.placeholder"
            :mensagem-campo-obrigatorio="configuration.errorMessage"
            :required="configuration.required"
            :disabled="configuration.disabled"
            :canClear="configuration.canClear"
            @valueSelect="$event => setValue($event, configuration)"
            @clear="$event => setValue(null, configuration, true)"
            ref="dynamicInput"
            v-e2e="configuration.id"
        ></TrfSelect>
    </template>
    <template v-else-if="type == 'periodo'">
      <TrfPeriodoInput
        :id="configuration.id"
        ref="dynamicInput"
        class="is-fullwidth"
        :data-inicial="configuration.dataInicial"
        :data-final="configuration.dataFinal"
        :label="configuration.label"
        :placeholder-inicial="configuration.placeholderInicial"
        :placeholder-final="configuration.placeholderFinal"
        :mensagem-campo-obrigatorio="configuration.errorMessage"
        :required="configuration.required"
        :disabled="configuration.disabled"
        @update:model-value="$event => setValue($event, configuration)"
        v-e2e="configuration.id"
      >
      </TrfPeriodoInput>
    </template>
    <template v-else-if="type == 'button-selector'">
        <TrfButtonSelector
            :id="configuration.id.id"
            :lista-de-opcoes="configuration.options"
            :label="configuration.label"
            :disabled="configuration.disabled"
            @update:opcaoSelecionada="$event => setValue($event?.value, configuration)"
            ref="dynamicInput"
            v-e2e="configuration.id.id"
        ></TrfButtonSelector>
    </template>
    <template v-else-if="type == 'checkbox-fields'">
        <TrfCheckboxFields
            :id="configuration.id.id"
            :lista-de-opcoes="configuration.options"
            :titulo="configuration.label"
            :disabled="configuration.disabled"
            @update:valores-selecionados="$event => setValue($event, configuration)"
            ref="dynamicInput"
            v-e2e="configuration.id.id"
        ></TrfCheckboxFields>
    </template>
    <template v-else-if="type == 'button'">
        <label>&nbsp;</label>
        <TrfButton
            :id="configuration.id"
            :nome="configuration.nome"
            :classCor="configuration.cor"
            :disabled="configuration.disabled"
            @click="$event => configuration.callbackFn($event)"
            ref="dynamicInput"
            v-e2e="configuration.id"
        ></TrfButton>
    </template>
  </div>
</template>
  
  <script>
import { defineAsyncComponent } from 'vue';
import { ConfigFiltro } from '../models/configFiltro.model.js';
import { utils } from '../../../util/utils.js';
  
  export default {
    name: "TrfFormFieldFacade",
    expose: ['limparCampo', 'setValue', 'replaceValue', 'type'],
    emits: ['value-change', 'error', 'clear', 'send-value'],
    components: {
      TrfInput: defineAsyncComponent(() => import('../../Input/index.vue')),
      TrfSelect: defineAsyncComponent(() => import('../../Select/index.vue')),
      TrfButtonSelector: defineAsyncComponent(() => import('../../ButtonSelector/index.vue')),
      TrfCheckboxFields: defineAsyncComponent(() => import('../../CheckboxFields/index.vue')),
      TrfButton: defineAsyncComponent(() => import('../../Button/index.vue')),
      TrfPeriodoInput: defineAsyncComponent(() => import('../../Input/TrfPeriodoInput.vue'))
    },
    props: {
      configuration: {
        type: Object,
        required: true,
        default: new ConfigFiltro()
      },
      type: {
        type: String,
        required: true,
        default: 'text'
      }
    },
    data() {
      return {
        value: this.configuration?.value? this.configuration.value : '',
        hasError: false,
      };
    },
    methods: {
      isValueEqual(value) {
        if (utils.isObject(value) && utils.isObject(this.value) && (JSON.stringify(value) === JSON.stringify(this.value))) {
          return true
        }
        if (Array.isArray(value) && Array.isArray(this.value)) {
          const biggerArray = value.length >= this.value.length? value : this.value;
          const smallerArray = value.length >= this.value.length? this.value : value;
          return biggerArray.every(v => smallerArray.includes(v))
        }
        return value === this.value
      },
      setValue(value, configuration, isClear = false) {
        if (this.type != 'periodo' && !isClear && this.isValueEqual(value)) return;
        this.value = value;
        this.emitValue(this.value, isClear);
        if (configuration.callbackFn != null) {
          configuration.callbackFn(value, configuration, this);
        }
      },
      emitValue(value, isClear = false) {
        this.$emit('value-change', value, isClear)
      },
      emitError(error) {
        this.$emit('error', error)
      },
      replaceValue(value) {
        if (this.type == 'button-selector') {
          this.replaceButtonSelectorValue(value)
        }
      },
      replaceButtonSelectorValue(value) {
        if (value === null && !this.$refs.dynamicInput.valor) {
          this.$refs.dynamicInput._selecionarDefault()
        } else {
          // @TODO Adicionar condição para preenccher valor quando se fizer necessário!
        }
      },
      limparCampo() {
        if (JSON.stringify(this.$refs) == JSON.stringify({})) return;
        if (this.type == 'periodo') {
          this.$refs.dynamicInput.limparInput(true)
        }
        if (this.type == 'button-selector') {
          this.$refs.dynamicInput.limparSelect()
        }
      },
      clear() {
        this.$emit('clear', true)
      },
    },
    mounted() {
    }, 
  };
  </script>
  
  <style lang="scss" scoped>
  
  </style>
  